import { useCallback, useEffect, useState } from 'react';
import { recordUiError } from '../observability';

export function useFeedback(page) {
  const [feedback, setFeedback] = useState(null);
  const dismissToast = useCallback(() => setFeedback(null), []);
  const showToast = useCallback(message => setFeedback({ message, tone: 'success' }), []);
  const showError = useCallback(message => {
    recordUiError({ message, page, source: 'toast' });
    setFeedback({ message, tone: 'error' });
  }, [page]);
  useEffect(() => {
    if (!feedback || feedback.tone === 'error') return undefined;
    const timer = setTimeout(dismissToast, 5000);
    return () => clearTimeout(timer);
  }, [feedback, dismissToast]);
  return { toast: feedback?.message || '', toastType: feedback?.tone || 'success', showToast, showError, dismissToast };
}
